import { render, staticRenderFns } from "./message-manage.vue?vue&type=template&id=42f02a45"
import script from "./message-manage.vue?vue&type=script&lang=ts"
export * from "./message-manage.vue?vue&type=script&lang=ts"
import style0 from "./message-manage.vue?vue&type=style&index=0&id=42f02a45&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports